// JavaScript source code
// src/utils/pmoStyles.js

export const PMO_BADGE_TONES = {
    neutral: {
        bg: "#F8FAFC",
        color: "#475569",
        border: "#E2E8F0",
    },
    danger: {
        bg: "#FFF1F2",
        color: "#BE123C",
        border: "#FECDD3",
    },
    warning: {
        bg: "#FFFBEB",
        color: "#B45309",
        border: "#FDE68A",
    },
    orange: {
        bg: "#FFF7ED",
        color: "#C2410C",
        border: "#FDBA74",
    },
    success: {
        bg: "#ECFDF5",
        color: "#047857",
        border: "#A7F3D0",
    },
    info: {
        bg: "#EFF6FF",
        color: "#1D4ED8",
        border: "#BFDBFE",
    },
    purple: {
        bg: "#F5F3FF",
        color: "#6D28D9",
        border: "#DDD6FE",
    },
};

function normalizeTooltipText(value) {
    return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
}

export function getPmoTooltip(value) {
    const text = normalizeTooltipText(value);

    if (!text) return "";

    if (text.includes("critica")) {
        return "Prioridad critica: requiere intervencion inmediata por riesgo alto para el proyecto.";
    }

    if (text.includes("alta")) {
        return "Prioridad alta: requiere atencion proxima por impacto, urgencia o relevancia operativa.";
    }

    if (text.includes("media")) {
        return "Prioridad media: seguimiento operativo necesario sin condicion critica inmediata.";
    }

    if (text.includes("baja")) {
        return "Prioridad baja: seguimiento normal dentro del flujo operativo.";
    }

    if (text.includes("terminada")) {
        return "Tarea finalizada dentro del flujo operativo del proyecto.";
    }

    if (text.includes("en proceso")) {
        return "Tarea actualmente en ejecucion.";
    }

    if (text.includes("pendiente")) {
        return "Tarea pendiente de inicio, avance o atencion operativa.";
    }

    if (text.includes("bloqueada")) {
        return "Tarea bloqueada: requiere intervencion antes de poder avanzar.";
    }

    if (text.includes("aprobado parcial")) {
        return "El avance fue validado, pero la tarea aun no esta terminada.";
    }

    if (text === "aprobado") {
        return "La tarea fue revisada y aprobada formalmente.";
    }

    if (text.includes("en revision")) {
        return "La tarea esta esperando revision o decision del responsable asignado.";
    }

    if (text.includes("sin revision activa")) {
        return "La tarea no tiene un flujo de revision abierto en este momento.";
    }

    if (text.includes("requiere ajustes")) {
        return "La revision solicito correcciones antes de aprobar el avance.";
    }

    if (text.includes("rechazado")) {
        return "El avance fue rechazado. El responsable debe corregir y reenviar la tarea a revision.";
    }

    if (text.includes("aprobado parcial")) {
        return "El avance fue validado, pero la tarea aun sigue en ejecucion y puede registrar el siguiente avance.";
    }

    if (text.includes("ruta bloqueada")) {
        return "La tarea no puede avanzar porque depende de otra actividad o tiene bloqueo operativo.";
    }

    if (text.includes("ruta liberada")) {
        return "La tarea puede avanzar porque no tiene bloqueo operativo activo.";
    }

    if (text.includes("evidencia completa")) {
        return "La tarea cuenta con evidencia y geoevidencia registradas.";
    }

    if (text.includes("falta geoevidencia")) {
        return "La tarea tiene evidencia, pero falta registrar ubicacion o coordenadas.";
    }

    if (text.includes("falta evidencia")) {
        return "La tarea aun no tiene evidencia registrada.";
    }

    if (text.includes("evidencia pendiente")) {
        return "La tarea requiere evidencia para completar su trazabilidad.";
    }

    if (text.includes("paquete wbs")) {
        return "Agrupador de tareas usado como punto de control del proyecto.";
    }

    if (text.includes("tarea wbs")) {
        return "Actividad operativa dentro de la estructura WBS del proyecto.";
    }

    if (text.includes("finaliza para iniciar")) {
        return "Dependencia FS: una tarea debe finalizar antes de que la siguiente pueda iniciar.";
    }

    if (text.includes("inicia con inicio")) {
        return "Dependencia SS: dos tareas pueden iniciar de forma relacionada o simultanea.";
    }

    if (text.includes("portafolio pmo")) {
        return "Vista global de todos los proyectos del portafolio PMO.";
    }

    if (text.includes("proyecto completo")) {
        return "Vista filtrada de un proyecto especifico con toda su informacion PMO.";
    }

    if (text.includes("avance oficial")) {
        return "Porcentaje registrado en la Ficha 360 del proyecto.";
    }

    if (text.includes("avance operativo")) {
        return "Promedio visual calculado con base en fases y tareas WBS.";
    }

    if (text.includes("vencida") || text.includes("vencido") || text.includes("dias")) {
        return "Tiempo de vencimiento o antiguedad operativa de la tarea.";
    }

    if (text.includes("%")) {
        return "Porcentaje de avance operativo registrado para esta tarea.";
    }

    if (text.includes("revisa")) {
        return "Usuario asignado como revisor dentro del flujo de aprobacion.";
    }

    if (text.includes("sin revisor")) {
        return "La tarea no tiene revisor asignado para validar avances.";
    }

    if (text.includes("vencimiento")) {
        return "Senal asociada a fechas objetivo vencidas o proximas a vencer.";
    }

    if (text.includes("revision")) {
        return "Senal asociada al flujo de revision y aprobacion.";
    }

    if (text.includes("gobierno")) {
        return "Senal de gobierno PMO: requiere control, asignacion o decision.";
    }

    if (text.includes("planeacion")) {
        return "Senal asociada a fechas, planificacion o estructura del proyecto.";
    }

    if (text.includes("inconsistencia")) {
        return "Senal de posible inconsistencia entre estado, avance o evidencia.";
    }

    if (text.includes("bloqueo")) {
        return "Senal de bloqueo operativo que requiere intervencion.";
    }

    if (text.includes("seguimiento")) {
        return "Accion que requiere monitoreo operativo o revision posterior.";
    }

    return "Indicador operativo PMO.";
}

export function getTaskStatusTone(status) {
    const value = normalizeTooltipText(status);

    if (value.includes("terminada")) return "success";
    if (value.includes("en proceso")) return "info";
    if (value.includes("bloqueada")) return "danger";
    if (value.includes("cancelada")) return "neutral";
    if (value.includes("pendiente")) return "warning";

    return "neutral";
}

export function getReviewStatusTone(task = {}) {
    const reviewStatus = normalizeTooltipText(task.review_status);

    if (reviewStatus.includes("aprobado")) return "success";
    if (reviewStatus.includes("rechazado")) return "warning";
    if (reviewStatus.includes("en_revision") || reviewStatus.includes("en revision")) return "purple";
    if (reviewStatus.includes("pendiente_revision") || reviewStatus.includes("pendiente revision")) return "purple";
    if (reviewStatus.includes("borrador")) return "neutral";

    return "neutral";
}

export function getRouteStatusTone(task = {}) {
    const status = normalizeTooltipText(task.status);
    const routeStatus = normalizeTooltipText(task.route_status);

    if (
        status.includes("bloqueada") ||
        routeStatus.includes("blocked") ||
        Number(task.is_blocked || 0) === 1
    ) {
        return "danger";
    }

    return "success";
}

export function getEvidenceStatusTone(item = {}) {
    const hasEvidence =
        Number(item.evidence_count || 0) > 0 ||
        Number(item.geo_evidences || 0) > 0 ||
        Number(item.total_geo_evidences || 0) > 0 ||
        Number(item.has_evidence || 0) === 1 ||
        Boolean(item.evidence_url) ||
        Boolean(item.file_name) ||
        Boolean(item.file_url) ||
        Boolean(item.title) ||
        Boolean(item.evidence_title);

    const hasGeo =
        Number(item.geo_evidence_count || 0) > 0 ||
        Number(item.has_geo || 0) === 1 ||
        Number(item.has_geoevidence || 0) === 1 ||
        Boolean(item.latitude && item.longitude) ||
        Boolean(item.geo_lat && item.geo_lng);

    if (hasEvidence && hasGeo) return "success";
    if (hasEvidence && !hasGeo) return "warning";

    return "danger";
}

export function getHealthTone(healthStatus) {
    const value = normalizeTooltipText(healthStatus);

    if (value.includes("verde")) return "success";
    if (value.includes("amarillo")) return "warning";
    if (value.includes("rojo")) return "danger";

    return "neutral";
}